import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import Login from '@/pages/Login';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function ProtectedRoute({ children }: ProtectedRouteProps): React.ReactElement {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();

  // While MSAL is processing the redirect response, show nothing to avoid
  // a flash of the login page before auth state is resolved.
  if (inProgress !== InteractionStatus.None) {
    return <></>;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;
